import { render, staticRenderFns } from "./add-change-permission.vue?vue&type=template&id=0295309c&scoped=true"
import script from "./add-change-permission.vue?vue&type=script&lang=js"
export * from "./add-change-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295309c",
  null
  
)

export default component.exports